import React, {useContext} from 'react';
import {FlatList, ListRenderItem, View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import {
  ScreenTypes,
  useWebScreenDimensions,
} from '../../hooks/useWebScreenDimensions';
import LastMinuteOptionTileCard from '../../screens/cart/components/LastMinuteOptionTileCard';
import ItemSeparator from '../ItemSeparator';
import LoadingImg from '../LoadingImg';
import Text from '../themed/Text';
import ContentView from '../ui-controls/layout/ContentView';

type ProductGridProps = {
  items: any[];
  isLoading?: boolean;
};

const Context = React.createContext({isLoading: false});

const ProductGrid = ({items, isLoading}: ProductGridProps) => {
  const {isWebDesktopScreen, screenType} = useWebScreenDimensions();

  let numColumns = 2;

  switch (screenType) {
    case ScreenTypes.mobile:
      numColumns = 2;
      break;
    case ScreenTypes.desktop:
      numColumns = 4;
      break;
    case ScreenTypes.desktopLarge:
      numColumns = 6;
      break;
  }

  const styles = useStyles({numColumns});

  return (
    <Context.Provider value={{isLoading: !!isLoading}}>
      <ContentView style={{flex: 1}} parentStyle={{flex: 1}}>
        {isLoading ? (
          <View
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              flexGrow: 1,
            }}>
            <LoadingImg />
          </View>
        ) : (
          <FlatList
            key={`product-flatlist-${numColumns}`}
            testID="product-flatlist"
            data={items}
            renderItem={({item, index}) => {
              return (
                <View key={index} style={styles.tileContainerStyle}>
                  <LastMinuteOptionTileCard fullWidth item={item} />
                </View>
              );
            }}
            columnWrapperStyle={styles.columnWrapperStyle}
            numColumns={numColumns}
            showsVerticalScrollIndicator={isWebDesktopScreen}
            initialNumToRender={isWebDesktopScreen ? 25 : 15}
            ItemSeparatorComponent={ItemSeparator}
            ListEmptyComponent={EmptyComponent}
          />
        )}
      </ContentView>
    </Context.Provider>
  );
};

const EmptyComponent = () => {
  const {isLoading} = useContext(Context);
  return isLoading ? (
    <LoadingImg />
  ) : (
    <View
      style={{
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: 200,
      }}>
      <Text variant="body2">NO PRODUCTS FOUND</Text>
    </View>
  );
};

const useStyles = makeStyles((theme, {numColumns}: {numColumns: number}) => {
  return {
    columnWrapperStyle: {
      gap: 8,
    },
    tileContainerStyle: {
      flex: 1 / numColumns,
    },
  };
});

export default ProductGrid;
